import { Directive, ElementRef, EventEmitter, HostBinding, HostListener, inject, Input, Output } from '@angular/core';
import { generateId } from '../../../../_core/utils/generate-id';

@Directive({
  selector: '[opacRadioElement]',
  exportAs: 'opacRadioElement',
})
export class RadioElementDirective {
  private readonly element: ElementRef<HTMLElement> = inject(ElementRef);
  private _checked = false;

  id = generateId();

  @HostBinding('attr.role') get hostRole() {
    return 'radio';
  }

  @HostBinding('attr.aria-checked') get hostAriaChecked() {
    return this.checked;
  }

  @HostBinding('class.disabled')
  @HostBinding('attr.aria-disabled')
  get hostClassDisabled() {
    return this.disabled;
  }

  @HostBinding('tabindex') get hostTabindex() {
    return '-1';
  }

  @HostListener('click')
  @HostListener('keydown.space')
  checkRadio() {
    if (this.disabled) {
      return;
    }

    this.checked = true;
    this.change.emit(this.checked);
  }

  /**
   * Determines radio checked state
   */
  @Input()
  get checked(): boolean {
    return this._checked;
  }
  set checked(value: boolean) {
    if (this._checked !== value) {
      this._checked = value;
    }
  }
  /**
   * Determines radio group name to work with other radios
   */
  @Input('opacRadioElement') name = '';
  /**
   * Sets boolean disabled state
   */
  @Input() disabled = false;
  /**
   * Determines input value
   */
  @Input() value: string;

  /**
   * Emits when value changes
   */
  @Output() change = new EventEmitter<boolean>();

  uncheckRadio() {
    if (this.disabled) {
      return;
    }

    this.checked = false;
    this.change.emit(this.checked);
  }

  focus() {
    this.element.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    this.element.nativeElement.focus();
  }
}
